import { httpClient } from "./httpClient";

const getAllLeaveApproves = () => {
  return httpClient.get("leaveApproves");
};

export default {
  getAllLeaveApproves,
};
